import {createReducer} from 'redux-act';
import {
  CLEAR_ACTIVE_LOCATIONS,
  CLEAR_FILTERS,
  CLEAR_LOCATION_OTTER_BRANDS,
  CREATE_BYOC_VIRTUAL_NUMBER,
  CREATE_BYOC_VIRTUAL_NUMBER_FAILURE,
  CREATE_BYOC_VIRTUAL_NUMBER_SUCCESS,
  DELETE_BYOC_VIRTUAL_NUMBER,
  DELETE_BYOC_VIRTUAL_NUMBER_FAILURE,
  DELETE_BYOC_VIRTUAL_NUMBER_SUCCESS,
  GET_BYOC_VIRTUAL_NUMBERS,
  GET_BYOC_VIRTUAL_NUMBERS_FAILURE,
  GET_BYOC_VIRTUAL_NUMBERS_SUCCESS,
  GET_LOCATION_OTTER_BRANDS,
  GET_LOCATION_OTTER_BRANDS_FAILURE,
  GET_LOCATION_OTTER_BRANDS_SUCCESS,
  PAGE_CHANGE,
  SEARCH_ACTIVE_LOCATIONS,
  SEARCH_ACTIVE_LOCATIONS_FAILURE,
  SEARCH_ACTIVE_LOCATIONS_SUCCESS,
  SEARCH_CHANGE,
  UPDATE_BYOC_VIRTUAL_NUMBER,
  UPDATE_BYOC_VIRTUAL_NUMBER_FAILURE,
  UPDATE_BYOC_VIRTUAL_NUMBER_SUCCESS
} from 'store/byocVirtualNumbers/action';

const PAGE_SIZE = 20;

const initialPaging = {
  total: 0,
  pageSize: PAGE_SIZE,
  pages: 0,
  page: 0
};

const initialOtterBrands = {
  locationId: null,
  isMultiBrand: false,
  storeIds: []
};

const initialState = () => ({
  loading: false,
  creating: false,
  updating: false,
  deleting: false,
  searchingLocations: false,
  activeLocations: [],
  loadingOtterBrands: false,
  otterBrands: initialOtterBrands,
  paging: initialPaging,
  search: '',
  rows: []
});

const computePages = (totalCount, pageSize) => {
  if (!totalCount || !pageSize) {
    return 0;
  }
  return Math.ceil(totalCount / pageSize);
};

const byocVirtualNumbersReducer = createReducer(
  {
    [GET_BYOC_VIRTUAL_NUMBERS]: (state) => ({
      ...state,
      loading: true
    }),
    [GET_BYOC_VIRTUAL_NUMBERS_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      rows: payload?.rows ?? [],
      paging: {
        ...state.paging,
        total: payload?.totalCount ?? 0,
        pages: computePages(payload?.totalCount ?? 0, state.paging.pageSize)
      }
    }),
    [GET_BYOC_VIRTUAL_NUMBERS_FAILURE]: (state) => ({
      ...state,
      loading: false
    }),
    [CREATE_BYOC_VIRTUAL_NUMBER]: (state) => ({
      ...state,
      creating: true
    }),
    [CREATE_BYOC_VIRTUAL_NUMBER_SUCCESS]: (state) => ({
      ...state,
      creating: false
    }),
    [CREATE_BYOC_VIRTUAL_NUMBER_FAILURE]: (state) => ({
      ...state,
      creating: false
    }),
    [UPDATE_BYOC_VIRTUAL_NUMBER]: (state) => ({
      ...state,
      updating: true
    }),
    [UPDATE_BYOC_VIRTUAL_NUMBER_SUCCESS]: (state) => ({
      ...state,
      updating: false
    }),
    [UPDATE_BYOC_VIRTUAL_NUMBER_FAILURE]: (state) => ({
      ...state,
      updating: false
    }),
    [GET_LOCATION_OTTER_BRANDS]: (state, payload) => ({
      ...state,
      loadingOtterBrands: true,
      otterBrands: {...initialOtterBrands, locationId: payload?.locationId}
    }),
    [GET_LOCATION_OTTER_BRANDS_SUCCESS]: (state, payload) => ({
      ...state,
      loadingOtterBrands: false,
      otterBrands: {
        locationId: payload?.locationId ?? null,
        isMultiBrand: Boolean(payload?.isMultiBrand),
        storeIds: payload?.storeIds ?? []
      }
    }),
    [GET_LOCATION_OTTER_BRANDS_FAILURE]: (state) => ({
      ...state,
      loadingOtterBrands: false,
      otterBrands: {
        ...initialOtterBrands,
        locationId: state.otterBrands.locationId,
        failed: true
      }
    }),
    [CLEAR_LOCATION_OTTER_BRANDS]: (state) => ({
      ...state,
      loadingOtterBrands: false,
      otterBrands: initialOtterBrands
    }),
    [DELETE_BYOC_VIRTUAL_NUMBER]: (state) => ({
      ...state,
      deleting: true
    }),
    [DELETE_BYOC_VIRTUAL_NUMBER_SUCCESS]: (state) => ({
      ...state,
      deleting: false
    }),
    [DELETE_BYOC_VIRTUAL_NUMBER_FAILURE]: (state) => ({
      ...state,
      deleting: false
    }),
    [SEARCH_ACTIVE_LOCATIONS]: (state) => ({
      ...state,
      searchingLocations: true
    }),
    [SEARCH_ACTIVE_LOCATIONS_SUCCESS]: (state, payload) => ({
      ...state,
      searchingLocations: false,
      activeLocations: payload ?? []
    }),
    [SEARCH_ACTIVE_LOCATIONS_FAILURE]: (state) => ({
      ...state,
      searchingLocations: false,
      activeLocations: []
    }),
    [CLEAR_ACTIVE_LOCATIONS]: (state) => ({
      ...state,
      activeLocations: [],
      searchingLocations: false
    }),
    [PAGE_CHANGE]: (state, payload) => ({
      ...state,
      paging: {
        ...state.paging,
        page: payload
      }
    }),
    [SEARCH_CHANGE]: (state, payload) => ({
      ...state,
      search: payload,
      paging: initialPaging
    }),
    [CLEAR_FILTERS]: (state) => ({
      ...state,
      search: '',
      paging: initialPaging
    })
  },
  initialState()
);

export default byocVirtualNumbersReducer;
